// AUTH
export const SIGN_IN_PAGE_URI = `/sign-in`;
export const HOME_PAGE_URI = `/home`;
export const EXEL_PAGE_URI = `/exel`;
export const STATISTICS_PAGE_URI = `/statistics`;
export const NOTIFICATIONS_PAGE_URI = `/notifications`;
const PROJECT = `/projects`;
export const PROJECTS_PAGE_URI = `${PROJECT}`;
export const PROJECT_PAGE_URI = `${PROJECT}/:projectId`;

// PARTICIPANTS
export const PARTICIPANTS_PAGE_URI = `/participants/:workspaceId`;
export const PARTICIPANT_PROFILE_PAGE_URI = `/participants/user/:userId`;



